import { logToSentry } from 'utils/networkErrorUtils';
import {
  translationPracticePostList,
  translationPracticeRequest,
} from 'utils/api/translationPracticeExpress';
import * as TranslationPracticeActions from './actions';

export const buildTranslationPracticeListQuery = ({
  bookId,
  pageId,
  classId,
  userRole,
  userId,
  teacherId,
} = {}) => {
  const payload = {};
  if (bookId !== undefined && bookId !== null && bookId !== '') payload.book_id = bookId;
  if (pageId !== undefined && pageId !== null && pageId !== '') payload.page = pageId;
  payload.class_id = classId || '';
  if (userId) payload.user_id = userId;
  if (userRole === 'student' || userRole === 'teacher') {
    payload.user_type = userRole;
  }
  if (userRole === 'student') {
    payload.teacher_id = teacherId;
  }
  return payload;
};

const normalizeListPayload = (res) => {
  if (Array.isArray(res)) return res;
  if (res && Array.isArray(res.data)) return res.data;
  if (res && Array.isArray(res.items)) return res.items;
  if (res && Array.isArray(res.rows)) return res.rows;
  return [];
};

const normalizeUpdatedRecord = (id, res) => {
  if (!res || typeof res !== 'object') return null;
  if (res.id != null) return res;
  if (res.data != null && typeof res.data === 'object') {
    return { ...res, id: id ?? res.id };
  }
  return { id, ...res };
};

export const handleListTranslationPractice = (payload = {}) => async (dispatch) => {
  try {
    const raw = await translationPracticePostList(payload);
    const list = normalizeListPayload(raw);
    await dispatch(TranslationPracticeActions.listTranslationPracticeSuccess(list));
    return list;
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'list translation practice',
        error,
        module: 'TRANSLATION_PRACTICE',
        operation: 'LIST_TRANSLATION_PRACTICE',
      });
    }
    await dispatch(TranslationPracticeActions.listTranslationPracticeFail(error));
  }
};

export const handleCreateTranslationPractice = (body, listQuery = {}) => async (dispatch) => {
  try {
    await translationPracticeRequest('/create', {
      method: 'POST',
      body,
    });
    await dispatch(handleListTranslationPractice(listQuery));
    return true;
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'create translation practice',
        error,
        module: 'TRANSLATION_PRACTICE',
        operation: 'CREATE_TRANSLATION_PRACTICE',
      });
    }
    throw error;
  }
};

export const handleUpdateTranslationPractice = (id, body, listQuery = {}) => async (dispatch) => {
  try {
    const updated = await translationPracticeRequest(`/update/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body,
    });
    const normalized = normalizeUpdatedRecord(id, updated);
    if (normalized) {
      await dispatch(TranslationPracticeActions.updateTranslationPracticeSuccess(normalized));
    } else {
      await dispatch(handleListTranslationPractice(listQuery));
    }
    return normalized || updated;
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'update translation practice',
        error,
        module: 'TRANSLATION_PRACTICE',
        operation: 'UPDATE_TRANSLATION_PRACTICE',
      });
    }
    await dispatch(TranslationPracticeActions.updateTranslationPracticeFail(error));
    throw error;
  }
};

export const handleDeleteTranslationPractice = (id) => async (dispatch) => {
  await dispatch(TranslationPracticeActions.deleteTranslationPractice());
  try {
    await translationPracticeRequest(`/delete/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
    await dispatch(TranslationPracticeActions.deleteTranslationPracticeSuccess({ id }));
    return { id };
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'delete translation practice',
        error,
        module: 'TRANSLATION_PRACTICE',
        operation: 'DELETE_TRANSLATION_PRACTICE',
      });
    }
    await dispatch(TranslationPracticeActions.deleteTranslationPracticeFail(error));
    throw error;
  }
};
